import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    behavior: { type: String, default: "drawer" }, // default = drawer
  }

  show(event) {
    // Non fare nulla se clic su un link o bottone interno
    if (event.target.closest("a, button")) return

    if (!this.hasUrlValue) {
      console.warn("URL mancante")
      return
    }

    if (this.behaviorValue === "redirect") {
      window.location.href = this.urlValue
    } else {
      const drawer = document.querySelector("[data-controller*='drawer']")
      if (!drawer) {
        console.warn("Drawer mancante")
        return
      }

      drawer.dispatchEvent(
        new CustomEvent("drawer:open", {
          detail: { url: this.urlValue },
          bubbles: true,
        })
      )
    }
  }

  stop(event) {
    event.stopPropagation()
  }
}
